


let Config = {
	appid:'wxef5cf840bb0aabc6',
	wx_auth_url: `https://open.weixin.qq.com/connect/oauth2/authorize?appid=#{{appid}}&redirect_uri=#{{url}}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`,
	
}
export default Config;


// WEBPACK FOOTER //
// ./src/utils/config.js